/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCodeNotEqual = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M5 18h2v2H5zM5 4h2v12H5zm6 10h8v2h-8zm0-6h8v2h-8z" fill="currentcolor" />
  </Icon>
);
export { SvgCodeNotEqual as CodeNotEqual };
